import React from 'react';

const SvgArrowsShrink3 = props => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    style={{
      color: '#242134',
      ...props.style
    }}
  >
    <path
      d="M14.143 1.714A1.286 1.286 0 0 1 15.429 3v3.753L21.806.377a1.286 1.286 0 0 1 1.817 1.817l-6.376 6.377H21a1.286 1.286 0 1 1 0 2.572h-6.857a1.286 1.286 0 0 1-1.286-1.286V3a1.286 1.286 0 0 1 1.286-1.286zM9.857 22.286A1.285 1.285 0 0 1 8.571 21v-3.753l-6.377 6.376a1.286 1.286 0 0 1-1.817-1.817l6.376-6.377H3a1.286 1.286 0 0 1 0-2.572h6.857a1.286 1.286 0 0 1 1.286 1.286V21a1.286 1.286 0 0 1-1.286 1.286z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowsShrink3;
